import axios from "axios";
import toastr from "toastr";

export default {
  async retriveUser({ commit }, user_id) {
    try {
      const response = await axios.get("/user");
      commit("SET_USER_RETRIVE", response.data);
      return response.data;
    } catch (error) {
      toastr.error("Error al completar la solicitud retriveUser");
    }
  },

  async getUserAuth({ commit, dispatch }) {
    try {
      const result = await axios.get("/user");
      commit("SET_USER", result.data);
      commit("setUserGlobal", result.data, { root: true });
      return result.data;
    } catch (e) {
      // ✅ si /user falla por token muerto, saca al login
      const status = e?.response?.status;
      if ([401, 419, 409].includes(status)) {
        await dispatch("forceLogout", null, { root: true });
        window.location.href = "/";
        return;
      }
      console.log(e);
    }
  },
};
